import Transfer from './_transfer';

export default Transfer;
